import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  header: {
    textAlign: 'center',
    fontWeight: 700,
    whiteSpace: 'break-spaces',
    color: theme.palette.brand.greenDark,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
  marginBottom: { marginBottom: theme.spacing(3) },
}));

interface Props {
  mobile: boolean;
  header: string;
  subheader?: string;
}

export default function GetStartedHeader({ mobile, header, subheader }: Props) {
  const classes = useStyles();

  return (
    <>
      <Typography
        variant={mobile ? 'h6' : 'h3'}
        className={classes.header + ' ' + (!subheader && classes.marginBottom)}
      >
        {header}
      </Typography>
      {subheader && (
        <Typography
          paragraph
          align="center"
          variant="h6"
          className={classes.marginBottom}
        >
          {subheader}
        </Typography>
      )}
    </>
  );
}
